<section #sectionRef class="flex flex-col rounded-md select-none">
    <app-calendar-header [(mode)]="_mode">
        <ng-content select="[buttons]" />
    </app-calendar-header>

    <ng-content />

    @if (mode() === "month") {
        <app-block-calendar />
    } @else {
        <app-timeline-calendar />
    }
</section>
